import { Button, H4, colors, typography, size } from '@everlywell/leaves';
import styled from 'styled-components';

const Container = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const Title = styled(H4)`
  font-weight: ${typography.weight.regular};
  margin-bottom: ${size.md}px;
`;

const Description = styled.p`
  ${typography.bodyText}
  margin-bottom: ${size.lg}px;
`;

const Body = styled.div`
  ${typography.captionText}
  margin-bottom: 1.5rem;
  width: 100%;

  a {
    color: ${colors.green6};
    font-weight: ${typography.weight.regular};
    text-decoration: none;
  }
`;

const Footer = styled.div`
  width: 100%;
`;

const CTA = styled(Button)`
  width: 100%;
`;

const OptionTitle = styled.div`
  ${typography.buttonText};
  color: ${colors.green5};
`;

const UL = styled.ul`
  list-style: none;
  margin-bottom: ${size.lg}px;
`;

const LI = styled.li`
  ${typography.bodyTextSmall}
  padding-left: ${size.md}px;
  position: relative;

  &::before {
    background-color: ${colors.teal6};
    border-radius: 50%;
    content: '';
    display: inline-block;
    height: 4px;
    left: 0;
    margin-right: ${size.xs1}px;
    position: absolute;
    top: ${size.xs1}px;
    width: 4px;
  }
`;

const RadioOptionHeading = styled.label`
  align-items: center;
  background-color: ${colors.green1};
  border-radius: 2px 2px 0 0;
  border: 1px solid ${colors.green2};
  color: ${colors.green3};
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  padding: ${size.sm}px ${size.sm}px ${size.sm}px ${size.lg}px;
`;

const RadioOption = styled.div`
  border: 1px solid ${colors.green2};
  border-radius: 2px;
  box-shadow: 0 7px 30px -10px #dce4e5;
  margin-bottom: ${size.lg}px;
  cursor: pointer;
  transition: all 0.15s ease-in-out;

  &:hover,
  &:focus {
    border: 1px solid ${colors.green3};

    ${RadioOptionHeading} {
      background-color: ${colors.green2};
      color: ${colors.green5};
    }
  }
`;

const RadioOptionContent = styled.div`
  padding: ${size.md}px ${size.lg}px;
  cursor: pointer;

  ${UL} {
    margin-bottom: 0;
  }

  ${LI} {
    ${typography.bodyTextXSmall};
    line-height: 22px;
    margin-bottom: ${size.sm}px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

export {
  Body,
  Container,
  CTA,
  Description,
  Footer,
  LI,
  OptionTitle,
  RadioOption,
  RadioOptionContent,
  RadioOptionHeading,
  Title,
  UL,
};
